const ID_TOKEN_KEY = "id_token" as string;
/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveClientId = (clientid: string): void => {
  window.localStorage.setItem("clientid", clientid);
};

export const getClientId = (): string | null => {
  return window.localStorage.getItem("clientid");
};

export const saveUserType = (userType: number): void => {
  window.localStorage.setItem("userType", userType?.toString());
};

export const saveUserData = (data) => {
  localStorage.setItem("userData", JSON.stringify(data));
};

export const getUserType = (): string | null => {
  return window.localStorage.getItem("userType");
};

export const getUserData = () => {
  return window.localStorage.getItem("userData");
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};
export const destroyClientid = (): void => {
  window.localStorage.removeItem("clientid");
};
export const destroyUsertype = (): void => {
  window.localStorage.removeItem("userType");
};
export const destroyUserData = (): void => {
  window.localStorage.removeItem("userData");
};

export default {
  getToken,
  saveToken,
  destroyToken,
  getClientId,
  getUserData,
  saveUserData,
  saveClientId,
  destroyClientid,
  destroyUsertype,
  destroyUserData,
  saveUserType,
  getUserType,
};
